// extracted by mini-css-extract-plugin
export default {"container":"ToolsAndToolsetsSection_container__MpsZW","tabsContainer":"ToolsAndToolsetsSection_tabsContainer__4wDYG","tabContent":"ToolsAndToolsetsSection_tabContent__3fHWu"};